module.exports = __webpack_public_path__ + "img/index12.67ed5d66.jpg";